const API_URL = process.env.REACT_APP_API_URL || '';

export interface CustomerData {
  companyName: string; contactName: string; email: string; phone: string;
  address: string; city: string; state: string; zipCode: string;
  businessType: string; employeeCount: string; currentItProvider?: string; specificNeeds?: string;
}
export interface ContractData {
  customerId: string; planId: string; planName: string; monthlyFee: number;
  signature: string; signatureDate: string; ipAddress?: string;
}
export interface PaymentData {
  contractId: string; customerId: string; amount: number; cardToken: string; cardLast4: string;
}
export interface SubscriptionStatus { customer: any; contracts: any[]; recentPayments: any[]; }

class SubscriptionApiService {
  private async request(path: string, method: string, body?: any) {
    const res = await fetch(`${API_URL}${path}`, {
      method, headers: { 'Content-Type': 'application/json' },
      body: body ? JSON.stringify(body) : undefined,
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.error || `Request failed (${res.status})`);
    return data;
  }

  async createCustomer(d: CustomerData) { return this.request('/subscription/customer', 'POST', d); }
  async createContract(d: ContractData) { return this.request('/subscription/contract', 'POST', d); }
  async processPayment(d: PaymentData) { return this.request('/subscription/payment', 'POST', d); }
  async getSubscriptionStatus(customerId: string) { return this.request(`/subscription/status?customerId=${customerId}`, 'GET'); }

  createCardToken(_: any): string { return `tok_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`; }
  validateCardNumber(n: string): boolean {
    const d = n.replace(/\D/g, '');
    if (d.length < 13 || d.length > 19) return false;
    let sum = 0, even = false;
    for (let i = d.length - 1; i >= 0; i--) { let x = parseInt(d[i]); if (even) { x *= 2; if (x > 9) x -= 9; } sum += x; even = !even; }
    return sum % 10 === 0;
  }
  getCardType(n: string): string {
    const d = n.replace(/\D/g, '');
    if (d.startsWith('4')) return 'Visa'; if (d.startsWith('5') || d.startsWith('2')) return 'Mastercard';
    if (d.startsWith('3')) return 'American Express'; if (d.startsWith('6')) return 'Discover'; return 'Unknown';
  }
}

export const subscriptionApi = new SubscriptionApiService();
